import Art from './Art';
import LifeDrawing from './LifeDrawing';
import Collab from './Collab';
import './Work.css';

function Work() {
  return (
    <section className="Work">
      <LifeDrawing />
      <Art />
      <Collab/>
    </section>
  );
}

export default Work;
